<template>
  <router-link :to="'/campaigns/'+campaign.id" class="card--campaign-wide">
    <div v-if="campaign.acf.merchant_logo" class="card--campaign-wide__image">
      <img :src="campaign.acf.merchant_logo">
    </div>
    <div class="card--campaign-wide__content">
      <span class="card--campaign-wide__category">
        Beauty
      </span>
      <span class="campaign-card__title">
        {{ campaign.title }}
      </span>
      <span class="card--campaign-wide__rate">
        Up to {{ campaign.acf.commission_rate }}
      </span>
    </div>
  </router-link>
</template>

<script>

export default {
  name: 'WideCampaignCard',
  components: {
  },
  props: {
    campaign: {
      type : Object
    }
  }
}
</script>

<style lang="scss" scoped>

@use "@/scss/mixins.scss";
@use "@/scss/variables.scss";
@import "../scss/styles.scss";

.card--campaign-wide{
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 1.3rem;
  padding-bottom: 1.45rem;
  border-bottom: 1px solid rgba($light_grey, 0.6);
  box-sizing: border-box;
  &:hover{
    cursor: pointer;
  }
  &__image{
    width: 7.5rem;
    box-sizing: border-box;
    display: flex;
    align-content: center;
    align-items: center;
    height: 100%;
  }
  &__content{
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    align-items: flex-start;
    overflow: hidden;
    padding-left: 2rem;
    span{
      width: 100%;
    }
  }
  &__title {
    font-size: 1rem;
    line-height: 1.3rem;
    font-weight: 600;
    color:$darkblue;
  }
  &__category {
    font-size: 1.2rem;
    line-height: 1.6rem;
    color: #666;
    margin-bottom: 0.15rem;
  }
  &__rate {
    margin-top: 0.2rem;
    font-size: 1.6rem;
    line-height: 1.9rem;
    color:$darkblue;
    font-weight: 600;
  }
  &:last-of-type{
    border: 0;
    margin-bottom: 0;
    padding-bottom: 1rem;
  }
}


</style>

